import React, { Fragment } from 'react';

type ReplaceArgs = (React.JSX.Element | string)[];

const replaceCurlyWithJsx = (value: string, ...args: ReplaceArgs): ReplaceArgs | string => {
    return value.split('{}').reduce((l, p, i) => {
        const arg = args[i - 1];
        if (i > 0 && typeof arg !== 'undefined') {
            if (typeof arg === 'object') {
                l.push(<Fragment key={value}>{arg}</Fragment>);
            } else {
                l.push(arg);
            }
        }
        l.push(p);
        return l;
    }, [] as ReplaceArgs);
};

export default replaceCurlyWithJsx;
